import { cva } from 'class-variance-authority';
import { FC } from 'react';

import { TransitionFields } from 'organisms/Transition/config';

const transitionStyles = cva('size-full bg-gray-900', {
  variants: {
    direction: {
      up: 'clip-ellipse',
      down: 'clip-ellipse-down',
    },
  },
});

const Transition: FC<TransitionFields> = ({ direction }) => (
  <div className="h-20 bg-primary-25">
    <div className={transitionStyles({ direction })} />
  </div>
);

export default Transition;
